import React, {useState} from 'react';
import { withStyles } from "@mui/styles";
import { Styles } from "../../../../config/design/styles";
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography} from '@mui/material';
import {connect} from "trim-redux";
import {useTranslation} from "react-i18next";
import {Close} from "@mui/icons-material";
import Button from "@mui/material/Button";
import {useLocation, useNavigate} from "react-router-dom";
import LoginDialog from "./LoginDialog"; // Import useMediaQuery and Theme

function AuthCheckerIconButton({ banner, classes,isAuth,icon,run,loading,className }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const navigation = useNavigate();
    const location = useLocation();
    const handleLogin = () => {
        localStorage.setItem("redirect", location.pathname);
        navigation('/login');
    }
    const handleClick = (e) => {
        e.preventDefault();
        !!isAuth ? run() : setOpen(true);
    }
    return (
        <>
            <IconButton
                className={className}
                onClick={(e) => handleClick(e)}
            >
                {icon}
            </IconButton>
            <LoginDialog open={open} setOpen={setOpen}/>
        </>

    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(AuthCheckerIconButton));
